<template>
    <li class="card card--course card--accommodation card--backed card--colour-white card--standard card--fixed">
        <a :href="url" class="card__inner" :class="{ 'text--center': center_align_card_content }" >
            <div class="card__body">
                <div class="card__image">
                    <div v-if="current_project_label" class="card__online-tag card__flag--red current-project-tag">Current project</div>
                    <img :src="image" :alt="'Project image for ' + title">
                </div>
                <div class="card__text">
                    <h3 v-html="title" class="card__title" :class="{ 'u-chevron u-chevron--inline': !hide_card_arrows }">
                        {{ title }}
                    </h3>
                    <div class="card__description" v-if="content !== null && card_text.length > 0">{{ card_text }}</div>
                </div>
            </div>
            <div class="card__footer card__tags" v-if="show_categories == true">
                <span class="card__tag u-accent" style="white-space: normal; display: block;">{{ categories_string }}</span>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        url: String,
        image: String,
        show_current_projects_label: Boolean,
        center_align_card_content: Boolean,
        hide_card_arrows: Boolean,
        title: String,
        content: String,
        categories: Array,
        show_categories: Boolean,
        categories_array: Array,
        categories_string: String
    },
    data() {
        return {
            card_text: ''
        }
    },
    watch: {        
        content() {      
            // Moved this call into a watch. Was not updating when content being filtered and using old text value
            this.card_text = this.trim_and_elipsis(this.content);
        }
    },
    computed: {
        current_project_label() {
            if(this.show_current_projects_label == true && this.categories.includes('Current project')) {
                return true
            } else { 
                return false
            }
        }
    },
    methods: {
        trim_and_elipsis(string) {
            if(string.length >= 165) {
                return string.substring(0,165) + '...';
            } else {
                return string;
            }
        }
    },
    created() {
        if(this.content !== null) {
            this.card_text = this.trim_and_elipsis(this.content);
        }
    }
}
</script>
